import { VgEmploymentState } from '@interfaces';
import { createSelector } from '@ngrx/store';
import { FilteredClientAccount } from '@shared/models';
import { ISelectedClientAccountsState } from '@store/reducers/selected-client-accounts/selected-client-accounts.reducer';
import { selectEmploymentMfeDataByOwnerIndex } from '@store/selectors/open-account/open-account.selectors';
import { selectAcceptedDAOffer } from '@store/selectors/open-choice/open-choice.selectors';

import { selectEligibleIndividualAccounts } from '../../client-accounts/client-accounts.selectors';
import { selectedClientAccountsState } from '../../selected-client-accounts/selected-client-accounts.selectors';
import { nullState } from '../common/router.selectors';
import {
  getMinorContactInfoNextPage,
  getMinorEmploymentNextPage,
  getMinorIncomeNetWorthNextPage,
  getMinorInvestObjNextPage,
  getMinorLetterUploadNextPage,
  getMinorPersonalInfoNextPage,
  getMinorReviewNextPage,
  getMinorSettlementFundNextPage,
  getMinorTermsNextPage,
  getMinorTransferFromNextPage,
  getMinorTransferToNextPage,
  getOpenChoiceEnrollPage,
} from './minor-transfer-router.helpers';
//minor selectors
export const selectMinorTransferFromNextPage = createSelector(
  selectEligibleIndividualAccounts(),
  (individualAccounts: FilteredClientAccount) => getMinorTransferFromNextPage(individualAccounts),
);
export const selectMinorTransferToNextPage = createSelector(
  selectedClientAccountsState,
  (selectedAccounts: ISelectedClientAccountsState) => getMinorTransferToNextPage(selectedAccounts),
);
export const selectMinorPersonalInfoNextPage = createSelector(nullState, () =>
  getMinorPersonalInfoNextPage(),
);
export const selectMinorContactInfoNextPage = createSelector(nullState, () =>
  getMinorContactInfoNextPage(),
);
export const selectMinorSettlementFundNextPage = createSelector(nullState, () =>
  getMinorSettlementFundNextPage(),
);
export const selectMinorEmploymentNextPage = createSelector(
  selectEmploymentMfeDataByOwnerIndex(0),
  (employment: Partial<VgEmploymentState> | undefined) => getMinorEmploymentNextPage(employment),
);
export const selectMinorLetterUploadNextPage = createSelector(nullState, () =>
  getMinorLetterUploadNextPage(),
);
export const selectMinorInvestObjNextPage = createSelector(nullState, () =>
  getMinorInvestObjNextPage(),
);
export const selectMinorIncomeNetWorthNextPage = createSelector(nullState, () =>
  getMinorIncomeNetWorthNextPage(),
);

export const selectMinorReviewNextPage = createSelector(
  selectedClientAccountsState,
  selectAcceptedDAOffer,
  (selectedAccounts: ISelectedClientAccountsState, acceptedDaOffer) => {
    if (acceptedDaOffer) {
      return getOpenChoiceEnrollPage();
    }
    return getMinorReviewNextPage(selectedAccounts);
  },
);
export const selectMinorTermsNextPage = createSelector(nullState, () => getMinorTermsNextPage());
